var _circle, _rect, _rect2, _polygon, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    width: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 60,
    fill: "#ddd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 23.94,
    width: 46.2,
    height: 55.2,
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 25.19,
    width: 46.2,
    height: 55.2,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "136.2 80.39 119.09 80.39 97.75 25.19 136.2 25.19 136.2 80.39",
    fill: "#f6f6f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.06,60.83V58.63H97.19v1.9H95.73a8.16,8.16,0,0,0-.38-1.41A7.7,7.7,0,0,0,94.8,58V56.27h8.26v-1.9H105v6.46Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,49.28a3.22,3.22,0,0,1-.34,1.49,3.14,3.14,0,0,1-1,1.14,5.21,5.21,0,0,1-1.66.74,8.94,8.94,0,0,1-2.29.26,8.75,8.75,0,0,1-2.27-.26,5.12,5.12,0,0,1-1.64-.74,3,3,0,0,1-1-1.14,3.55,3.55,0,0,1,0-3,3,3,0,0,1,1-1.14,5.12,5.12,0,0,1,1.64-.74,8.71,8.71,0,0,1,2.27-.26,8.9,8.9,0,0,1,2.29.26,5.21,5.21,0,0,1,1.66.74,3.14,3.14,0,0,1,1,1.14A3.21,3.21,0,0,1,105.15,49.28Zm-1.82,0a1.08,1.08,0,0,0-.15-.56,1.23,1.23,0,0,0-.55-.45,3.91,3.91,0,0,0-1.07-.3,11.69,11.69,0,0,0-1.71-.1,11.53,11.53,0,0,0-1.7.1,3.55,3.55,0,0,0-1,.3,1.19,1.19,0,0,0-.52.45,1.12,1.12,0,0,0-.14.56,1.08,1.08,0,0,0,.14.54,1.19,1.19,0,0,0,.52.45,3.72,3.72,0,0,0,1,.3,10.4,10.4,0,0,0,1.7.11,10.54,10.54,0,0,0,1.71-.11,4.1,4.1,0,0,0,1.07-.3,1.23,1.23,0,0,0,.55-.45A1,1,0,0,0,103.33,49.28Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,43.12a2.28,2.28,0,0,0,.5-.69,2,2,0,0,0,.22-.88,2,2,0,0,0-.16-.8,1.62,1.62,0,0,0-.54-.65,3,3,0,0,0-1-.45,6.56,6.56,0,0,0-1.5-.2,2.41,2.41,0,0,1,.46.45,3.16,3.16,0,0,1,.34.53,2.82,2.82,0,0,1,.21.54,2,2,0,0,1,.07.51A3.67,3.67,0,0,1,101,42.7a2.57,2.57,0,0,1-.58,1,2.68,2.68,0,0,1-1,.63,3.81,3.81,0,0,1-1.39.23,3.54,3.54,0,0,1-1.42-.27,3.35,3.35,0,0,1-1.08-.73,3.05,3.05,0,0,1-.68-1.07,3.67,3.67,0,0,1-.23-1.3,3.72,3.72,0,0,1,.29-1.43,3.33,3.33,0,0,1,.9-1.23,4.6,4.6,0,0,1,1.56-.86,7.11,7.11,0,0,1,2.3-.33,7.87,7.87,0,0,1,2.46.34,5.09,5.09,0,0,1,1.71.91,3.63,3.63,0,0,1,1,1.31,3.8,3.8,0,0,1,.33,1.54,3.91,3.91,0,0,1-.37,1.75,4.59,4.59,0,0,1-.85,1.22Zm-3-2.1a1.6,1.6,0,0,0-.22-.78,2.11,2.11,0,0,0-.78-.74,3,3,0,0,0-1.66.6,1.34,1.34,0,0,0-.46,1,1.22,1.22,0,0,0,.39.9,1.75,1.75,0,0,0,1.26.38A1.44,1.44,0,0,0,99.16,42,1.43,1.43,0,0,0,99.49,41Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,34.67A2.26,2.26,0,0,0,103,34a2,2,0,0,0,.22-.88,2,2,0,0,0-.16-.8,1.61,1.61,0,0,0-.54-.65,3,3,0,0,0-1-.45,6.45,6.45,0,0,0-1.5-.2,2.45,2.45,0,0,1,.46.45,3.07,3.07,0,0,1,.34.53,2.85,2.85,0,0,1,.21.54,2,2,0,0,1,.07.51,3.65,3.65,0,0,1-.19,1.21,2.58,2.58,0,0,1-.58,1,2.68,2.68,0,0,1-1,.63,3.79,3.79,0,0,1-1.39.23,3.54,3.54,0,0,1-1.42-.27,3.37,3.37,0,0,1-1.08-.73A3.06,3.06,0,0,1,94.84,34a3.68,3.68,0,0,1-.23-1.3,3.73,3.73,0,0,1,.29-1.43,3.35,3.35,0,0,1,.9-1.23,4.6,4.6,0,0,1,1.56-.86,7.09,7.09,0,0,1,2.3-.33,7.9,7.9,0,0,1,2.46.34,5.14,5.14,0,0,1,1.71.91,3.64,3.64,0,0,1,1,1.31,3.8,3.8,0,0,1,.33,1.54,3.91,3.91,0,0,1-.37,1.75,4.57,4.57,0,0,1-.85,1.22Zm-3-2.1a1.59,1.59,0,0,0-.22-.78,2.09,2.09,0,0,0-.78-.74,3,3,0,0,0-1.66.6,1.34,1.34,0,0,0-.46,1,1.22,1.22,0,0,0,.39.9,1.75,1.75,0,0,0,1.26.38,1.44,1.44,0,0,0,1.14-.38A1.43,1.43,0,0,0,99.49,32.58Z",
    fill: "#666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.68,
    y: 14.13,
    width: 64.94,
    height: 35.94,
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.68,
    y: 16.6,
    width: 60.93,
    height: 29.78,
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.47 60.1 3.82 60.1 12.68 49.98 77.62 49.98 86.47 60.1",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.11,
    y1: 51.45,
    x2: 73.19,
    y2: 51.45,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.45,
    y1: 54.1,
    x2: 74.96,
    y2: 54.1,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.79,
    y1: 56.76,
    x2: 77.62,
    y2: 56.76,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.82,
    y: 60.1,
    width: 82.65,
    height: 4.29,
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.72,118.43c0-2.65-10.59-4.8-56.06-4.8s-57.31,2.15-57.31,4.8,11.84,4.8,57.31,4.8S114.72,121.08,114.72,118.43Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.06,108H79a10.77,10.77,0,0,1,20.51,0h9.75V92.76a110.82,110.82,0,0,0-22.06-4.33L77.69,74.35H57.3c-2.25,0-2.07,12.38-2.07,12.38Z",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.67,108a10.77,10.77,0,0,1,20.51,0H54V89.23H8V108Z",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.99,
    y1: 89.23,
    x2: 8.01,
    y2: 89.23,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.2 76.88 62.86 76.88 62.86 88.12 83.04 88.12 76.2 76.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "83.04 88.12 76.2 76.88 65.73 76.88",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.39,
    cy: 97.76,
    r: 2.08,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.92,
    cy: 111.26,
    r: 8.61,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.23,
    cy: 111.26,
    r: 8.61,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.92,
    cy: 111.26,
    r: 5.16,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.23,
    cy: 111.26,
    r: 5.16,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.23,
    y1: 91.16,
    x2: 67.98,
    y2: 91.16,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 95.66,
    width: 3.38,
    height: 6.5,
    fill: "#f2fbff",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,103.8h0A10.78,10.78,0,0,1,99.48,108h10.87V103.8",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.09,103.8l0,4.16H79a10.78,10.78,0,0,1,2.49-4.16",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.68,103.8h0A10.78,10.78,0,0,1,41.17,108L54,108v-4.16",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16,103.8A10.78,10.78,0,0,0,20.67,108H6.45l0-4.16H8",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfEmployment);
export default __webpack_public_path__ + "static/media/self-employment.987ed228.svg";
export { ForwardRef as ReactComponent };